import { all, takeEvery, put, call } from 'redux-saga/effects';
import referralsActions from './actions';
import { rsf, db } from '@iso/lib/firebase/firebase';
import { getCurrentUserEmail } from '@iso/lib/firebase/firebase.authentication.util';
import { cloneReferral } from '@iso/lib/remod-helpers/globalHelpers';
import { splitArrayIntoMultipleArraysForSagaQuery } from '@iso/lib/remod-helpers/globalHelpers';

import moment from "moment";

function* loadNotOwnedReferralsSaga() {
    let notOwnedReferrals = {};
    let groupedByPhone = {};
    try {
        const homeOwnerEmails = yield call(fetchHomeOwnersBasedOnGroupsCurrentLoggedUser);
        let multipleArrays = splitArrayIntoMultipleArraysForSagaQuery(homeOwnerEmails);
        for (let i = 0; i < multipleArrays.length; i++) {
            const collectionReference = db
                .collection('referrals')
                .where('createdBy', 'in', multipleArrays[i]);
            const referralsSnapshot = yield call(rsf.firestore.getCollection, collectionReference);
            referralsSnapshot.forEach((referral) => {
                notOwnedReferrals[referral.id] = {
                    ...referral.data()
                };
            });
        }
        groupedByPhone = executeGrouppingFetchedReferrals(notOwnedReferrals);
        yield put(
            referralsActions.createLoadNotOwnedReferralsActionSuccess({
                collection: groupedByPhone,
            })
        );
    } catch (error) {
        yield put(
            referralsActions.createLoadNotOwnedReferralsActionFailed({
                referralsError: error
            })
        );
    }
}

function executeGrouppingFetchedReferrals(notOwnedReferrals) {
    const groupedByPhone = {};
    for (const entry of Object.values(notOwnedReferrals)) {
        const phone = entry.phone;
        const currentRate = entry.rate ? '\nRate: ' + entry.rate : '';
        if (!groupedByPhone[phone]) {
            groupedByPhone[phone] = { ...entry };
            groupedByPhone[phone].createdByWithReview = `${entry.createdBy}- ${moment(entry.createdAt).format("MM/DD/YYYY")}- ${entry.zipCode}${currentRate}\n${entry.review}`;
            groupedByPhone[phone].urls = entry.files ? entry.files.map(file => file.url) : [];
        } else {
            const existingEmails = groupedByPhone[phone].email.split(',');
            if (!existingEmails.includes(entry.email)) {
                existingEmails.push(entry.email);
                groupedByPhone[phone].email = existingEmails.join(',');
            }

            const existingReferededPeople = groupedByPhone[phone].createdBy.split(',');
            if (!existingReferededPeople.includes(entry.createdBy)) {
                existingReferededPeople.push(entry.createdBy);
                groupedByPhone[phone].createdBy = existingReferededPeople.join(',');
            }

            const existingZipCodes = groupedByPhone[phone].zipCode.split(',');
            if (!existingZipCodes.includes(entry.zipCode)) {
                existingZipCodes.push(entry.zipCode);
                groupedByPhone[phone].zipCode = existingZipCodes.join(',');
            }

            const currentCombined = `${entry.createdBy} - ${moment(entry.createdAt).format("MM/DD/YYYY")}- ${entry.zipCode}${currentRate}\n${entry.review}`;
            const existingCreatedByWithReview = groupedByPhone[phone].createdByWithReview.split('\n\n');
            if (!existingCreatedByWithReview.includes(currentCombined)) {
                existingCreatedByWithReview.push(currentCombined);
                groupedByPhone[phone].createdByWithReview = existingCreatedByWithReview.join('\n\n');
            }

            const currentUrls = entry.files ? entry.files.map(file => file.url) : [];
            const existingUrls = groupedByPhone[phone].urls;
            currentUrls.forEach(currentUrl => {
                if (!existingUrls.includes(currentUrl)) {
                    existingUrls.push(currentUrls);
                }
            });
            groupedByPhone[phone].urls = existingUrls;
        }
    }
    return groupedByPhone;
}

function* fetchHomeOwnersBasedOnGroupsCurrentLoggedUser() {
    const homeOwnerEmails = [];
    const loggedInUserEmail = yield call(getCurrentUserEmail);
    const userQuerySnapshot = yield call(
        rsf.firestore.getCollection, db.collection('users').where('email', '==', loggedInUserEmail)
    );
    let userDetails;
    if (!userQuerySnapshot.empty) {
        userDetails = userQuerySnapshot.docs[0].data();
    } else {
        throw new Error('User with specified email not found');
    }
    let multipleArrays = splitArrayIntoMultipleArraysForSagaQuery(userDetails.userGroups);
    for (let i = 0; i < multipleArrays.length; i++) {
        const usersRef = db.collection('users')
            .where('userGroups', 'array-contains-any', multipleArrays[i]);
        const usersSnapshot = yield call(rsf.firestore.getCollection, usersRef);
        usersSnapshot.forEach((userDoc) => {
            const userData = userDoc.data();
            if (userData.email === userDetails.email) {
                return;
            }
            homeOwnerEmails.push(userData.email);
        });
    }
    return homeOwnerEmails;
}

function* loadOwnedReferralsSaga() {
    let notOwnedReferrals = {};
    try {
        const loggedInUserEmail = yield call(getCurrentUserEmail);
        const collectionReference = db
            .collection('referrals')
            .where('createdBy', '==', loggedInUserEmail);
        const referralsSnapshot = yield call(rsf.firestore.getCollection, collectionReference);
        referralsSnapshot.forEach((referral) => {
            notOwnedReferrals[referral.id] = {
                ...referral.data(),
                urls: referral.data().files ? referral.data().files.map(file => file.url) : []
            };
        });
        yield put(
            referralsActions.createLoadNotOwnedReferralsActionSuccess({
                collection: notOwnedReferrals,
            })
        );
    } catch (error) {
        yield put(
            referralsActions.createLoadNotOwnedReferralsActionFailed({
                referralsError: error
            })
        );
    }
}

function* createReferralSaga({ payload }) {
    try {
        const loggedInUserEmail = yield call(getCurrentUserEmail);
        payload.createdBy = loggedInUserEmail;
        payload.lastModifiedBy = loggedInUserEmail;
        if (payload.files) {
            const files = [];
            yield all(payload.files
                .filter(item => item.action === 'add')
                .map(item => call(addFile, item.file, files))
            );
            payload.files = files;
        }
        const referral = cloneReferral(payload);
        const id = db.collection('referrals').doc().id;
        yield call(rsf.firestore.setDocument, 'referrals/' + id, referral);
        yield put(
            referralsActions.createCreateReferralActionSuccess({
                referralsSuccess: '',
            })
        );
        yield put(
            referralsActions.createLoadOwnedReferralsActionStart()
        );
    } catch (error) {
        yield put(
            referralsActions.createCreateReferralActionFailed({
                referralsError: error,
            })
        );
    }
}

function* addFile(file, result) {
    const task = yield call(rsf.storage.uploadFile, "files/" + file.name, file);
    yield task
    const url = yield call(rsf.storage.getDownloadURL, "files/" + file.name);
    const resultUrl = yield call(fetch, url);
    result.push({ 'url': resultUrl.url, 'name': file.name });
};

function* removeFile(file) {
    const task = yield call(rsf.storage.deleteFile, "files/" + file.name);
    yield task
};

function* deleteReferralSaga({ payload }) {
    const id = payload.referralId;
    const snapshot = yield call(rsf.firestore.getDocument, 'referrals/' + id);
    const referal = snapshot.data();
    if (referal.files && referal.files.length > 0) {
        yield all(referal.files.map(file => call(removeFile, file)));
    }
    try {
        yield call(rsf.firestore.deleteDocument, "referrals/" + id);
        yield put(
            referralsActions.createCreateReferralActionSuccess({
                referralsSuccess: '',
            })
        );
        yield put(
            referralsActions.createLoadOwnedReferralsActionStart()
        );
    } catch (error) {
        yield put(
            referralsActions.createDeleteReferralActionFailed({
                referralsError: error,
            })
        );
    }
}

function* editReferralSaga({ payload }) {
    try {
        const loggedInUserEmail = yield call(getCurrentUserEmail);
        payload.createdBy = payload.createdBy ?? loggedInUserEmail;
        payload.lastModifiedBy = loggedInUserEmail;
        payload.lastModifiedAt = undefined;
        const id = payload.key;
        if (payload.files) {
            const toAdd = [];
            const unmodified = payload.files
                .filter(item => item.action === undefined).map(item => ({ name: item.name, url: item.url }));
            yield all(payload.files
                .filter(item => item.action === 'add')
                .map(item => call(addFile, item.file, toAdd))
            );
            yield all(payload.files.filter(item => item.action === 'delete')
                .map(item => call(removeFile, item.file)));
            payload.files = unmodified.concat(toAdd);
        }
        const referral = cloneReferral(payload);
        yield call(rsf.firestore.setDocument, 'referrals/' + id, referral);
        yield put(
            referralsActions.createEditReferralActionSuccess({
                referralsSuccess: '',
            })
        );
        yield put(
            referralsActions.createLoadOwnedReferralsActionStart()
        );
    } catch (error) {
        yield put(
            referralsActions.createEditReferralActionFailed({
                referralsError: error,
            })
        );
    }
}

function* clearFlags() {
    yield put(
        referralsActions.createLoadNotOwnedReferralsActionSuccess({
            referralsSuccess: '',
            referralsError: ''
        })
    );
}

export default function* referralsSaga() {
    yield all([
        takeEvery(referralsActions.LOAD_NOT_OWNED_REFERRALS_START, loadNotOwnedReferralsSaga),
        takeEvery(referralsActions.LOAD_OWNED_REFERRALS_START, loadOwnedReferralsSaga),
        takeEvery(referralsActions.CREATE_REFERRAL_START, createReferralSaga),
        takeEvery(referralsActions.EDIT_REFERRAL_START, editReferralSaga),
        takeEvery(referralsActions.DELETE_REFERRAL_START, deleteReferralSaga),
        takeEvery(referralsActions.CLEAR_FLAGS, clearFlags)
    ]);
}
